export const OPEN_DRAWER = 'drawers/OPEN_DRAWER';
export const CLOSE_DRAWER = 'drawers/CLOSE_DRAWER';
export const TOGGLE_DRAWER = 'drawers/TOGGLE_DRAWER';
export const OPEN_EXCLUSIVE = 'drawers/OPEN_EXCLUSIVE';
export const TOGGLE_EXCLUSIVE = 'drawers/TOGGLE_EXCLUSIVE';
export const OPEN_MAP_DETAIL_EXCLUSIVE = 'drawers/OPEN_MAP_DETAIL_EXCLUSIVE';
export const CLOSE_ALL = 'drawers/CLOSE_ALL';
